/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import TooltipForReceptionist from 'components/TooltipForReceptionist';
import PERM from 'constants/core/perm.const';
import IN from 'constants/in';
import { useTranslation } from 'providers/GILT.provider';
import logger from 'utils/logger.util';

import InputFieldContainer from 'onboarding/common/InputField';
import InputWithDropdownContainer from 'onboarding/common/InputWithDropdown';
import { getRoles } from 'onboarding/roles/actions';
import { AddServiceWithRole } from 'onboarding/services/AddServiceWithRole';

const L = logger('AddService');

export const AddService = ({
  settingsLayout = false,
  onServiceNameChange,
  onCategoryChange,
  onPrincingChange,
  isNameSelected,
  onCategoryChangeInSettings,
  category,
  onRolePriceBlur,
  onRoleApplicationChange,
  quickSetupLayout,
  onRoleCheckboxChange,
  onRoleProcessingChange,
  onRolePriceChange,
  service,
  serviceId,
  selectTemplate,
  addNewService,
  serviceTemplates,
  onSelectTax,
  onSelectFee,
  onToggleExempt,
  onChangeReason,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentSalon = useSelector((state) => state.currentSalon);
  const roles = useSelector((state) => state.onboarding.roles.roles);
  const categories = useSelector((state) => state.onboarding.services.categories);

  useEffect(() => {
    // TODO: possible multiple requests, if so, move to common parent
    dispatch(getRoles(currentSalon.id));
  }, [dispatch, currentSalon.id]);

  const onInputChange = (value) => void onServiceNameChange(value);
  const changeCategory = (category) => void onCategoryChange(category);
  const changePricing = (value) => void onPrincingChange(value);

  const serviceName = service && service.name;
  L.debug('render()', serviceId, serviceName, { service, roles, category, categories });

  // NOTE: parent has difficulty holding onto the service object, but the serviceId is correct
  // so, this possible workaround uses the fetched roles to find the proper service for the id
  // const service = L.debug('render()', 'service:', findService({ serviceId, roles }));

  return (
    <div data-bem="AddService" className="content auto-height  obs-edit-input cfix">
      {!isNameSelected && !quickSetupLayout && (
        <InputWithDropdownContainer
          data={{
            id: 'ServiceNameInput',
            label: t('composite.addService.serviceNameLabel'),
            type: 'text',
            placeholder: t('composite.addService.serviceNamePlaceholder'),
            inputValue: serviceName,
            inputMode: 'text',
          }}
          autoFocus
          templates={serviceTemplates}
          onNewClick={addNewService}
          onSelect={selectTemplate}
          onChangeHandler={onInputChange}
        />
      )}
      {isNameSelected && !quickSetupLayout && (
        <>
          <div className="cfix relative">
            <InputFieldContainer
              data={{
                id: 'ServiceNameInput',
                label: t('composite.addService.serviceNameLabel'),
                type: 'text',
                placeholder: t('composite.addService.serviceNamePlaceholder'),
                inputValue: service ? serviceName : '',
                inputMode: 'text',
              }}
              onChangeHandler={onInputChange}
            />
            <TooltipForReceptionist permission={PERM.canEditServices} where={IN.serviceEdit} />
          </div>
        </>
      )}
      {isNameSelected && currentSalon.pricing_type !== 'service' && (
        <AddServiceWithRole
          serviceId={serviceId}
          service={service}
          categories={categories}
          selectedCategory={category}
          quickSetupLayout={quickSetupLayout}
          roles={roles}
          onCategoryChange={changeCategory}
          onCategoryChangeInSettings={onCategoryChangeInSettings}
          onCheckboxChange={onRoleCheckboxChange}
          onPriceChange={onRolePriceChange}
          onPriceBlur={onRolePriceBlur}
          onApplicationChange={onRoleApplicationChange}
          onProcessingChange={onRoleProcessingChange}
          onPrincingChange={changePricing}
          settingsLayout={settingsLayout}
          onSelectTax={onSelectTax}
          onSelectFee={onSelectFee}
          onToggleExempt={onToggleExempt}
          onChangeReason={onChangeReason}
        />
      )}
    </div>
  );
};
